import { parsePhoneNumber } from 'libphonenumber-js';

export const parsePhoneForInput = (
  phoneNumber: string,
  phoneCode: string,
  location?: string | null
) => {
  if (!phoneNumber) return undefined;

  if (phoneNumber.trim().startsWith('+')) {
    try {
      const parsed = parsePhoneNumber(phoneNumber.trim());
      return {
        countryCode: location || parsed?.country,
        dialCode: phoneCode,
        number: parsed?.nationalNumber ?? phoneNumber,
      };
    } catch {
      return {
        countryCode: location || undefined,
        dialCode: phoneCode,
        number: phoneNumber,
      };
    }
  }

  if (!phoneCode) {
    return {
      countryCode: location || undefined,
      dialCode: '',
      number: phoneNumber,
    };
  }

  if (location) {
    return {
      countryCode: location,
      dialCode: phoneCode,
      number: phoneNumber,
    };
  }

  try {
    const parsed = parsePhoneNumber(`${phoneCode}${phoneNumber}`);
    return {
      countryCode: parsed?.country,
      dialCode: phoneCode,
      number: phoneNumber,
    };
  } catch {
    return {
      countryCode: undefined,
      dialCode: phoneCode,
      number: phoneNumber,
    };
  }
};
